import { Network } from '@capacitor/network';
import { isNative } from './platform';

/**
 * 网络状态。上传队列靠它在恢复联网的瞬间立刻续传，
 * 而不是傻等下一轮 30 秒轮询 —— 工人可能刚走到有信号的地方就又走开了。
 */

export async function isOnline(): Promise<boolean> {
  if (!isNative) return navigator.onLine;
  const status = await Network.getStatus();
  return status.connected;
}

/** 订阅联网事件，返回取消订阅的函数 */
export function onOnline(handler: () => void): () => void {
  if (!isNative) {
    window.addEventListener('online', handler);
    return () => window.removeEventListener('online', handler);
  }

  const listener = Network.addListener('networkStatusChange', (status) => {
    if (status.connected) handler();
  });
  return () => {
    void listener.then((l) => l.remove());
  };
}
